module.exports = __webpack_public_path__ + "static/media/paredes_vivas_9.cbbeaf24.jpg";